import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttachmentDownloadUrl, FuelSupplierAttachmentGetRecord } from '../types';

@Injectable({
  providedIn: 'root',
})
export class FuelSupplierAttachmentService {
  private readonly baseUrl = '/api/fuel-supplier';

  constructor(private http: HttpClient) {}

  getAttachments(
    fuelSupplierId: number
  ): Observable<FuelSupplierAttachmentGetRecord[]> {
    return this.http.get<FuelSupplierAttachmentGetRecord[]>(
      `${this.baseUrl}/${fuelSupplierId}/attachment`
    );
  }

  getAttachmentDownloadUrl(
    attachmentId: number
  ): Observable<AttachmentDownloadUrl> {
    return this.http.get<AttachmentDownloadUrl>(
      `${this.baseUrl}/attachment/${attachmentId}/download-url`
    );
  }

  uploadAttachment(fuelSupplierId: number, attachment: File) {
    const formData = new FormData();
    formData.append('attachment', attachment);

    return this.http.post<any>(
      `${this.baseUrl}/${fuelSupplierId}/attachment`,
      formData
    );
  }

  deleteAttachment(attachmentId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/attachment/${attachmentId}`);
  }
}
